import { render, staticRenderFns } from "./ChecklistActivity5.vue?vue&type=template&id=6ed6f940&"
import script from "./ChecklistActivity5.vue?vue&type=script&lang=js&"
export * from "./ChecklistActivity5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports